import React, { SVGProps } from "react";

const PrintOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 11.5H12.75C13.0812 11.499 13.3986 11.367 13.6328 11.1328C13.867 10.8986 13.999 10.5812 14 10.25V5.25C13.999 4.91878 13.867 4.60142 13.6328 4.36721C13.3986 4.133 13.0812 4.00099 12.75 4H3.25C2.91878 4.00099 2.60142 4.133 2.36721 4.36721C2.133 4.60142 2.00099 4.91878 2 5.25V10.25C2.00099 10.5812 2.133 10.8986 2.36721 11.1328C2.60142 11.367 2.91878 11.499 3.25 11.5H4"
      stroke="black"
      stroke-width="0.75"
      stroke-linejoin="round"
    />
    <path
      d="M11.24 7.5H4.76C4.34026 7.5 4 7.84026 4 8.26V13.24C4 13.6597 4.34026 14 4.76 14H11.24C11.6597 14 12 13.6597 12 13.24V8.26C12 7.84026 11.6597 7.5 11.24 7.5Z"
      stroke="black"
      stroke-width="0.75"
      stroke-linejoin="round"
    />
    <path
      d="M12 4V3.25C11.999 2.91878 11.867 2.60142 11.6328 2.36721C11.3986 2.133 11.0812 2.00099 10.75 2H5.25C4.91878 2.00099 4.60142 2.133 4.36721 2.36721C4.133 2.60142 4.00099 2.91878 4 3.25V4"
      stroke="black"
      stroke-width="0.75"
      stroke-linejoin="round"
    />
    <path
      d="M12.25 6.5C12.6642 6.5 13 6.16421 13 5.75C13 5.33579 12.6642 5 12.25 5C11.8358 5 11.5 5.33579 11.5 5.75C11.5 6.16421 11.8358 6.5 12.25 6.5Z"
      fill="black"
    />
  </svg>
);

export default PrintOutline;
